import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { Table, Tag, Button, Select, Checkbox, Card, Row, Col, Modal, Radio, Avatar, Spin, Input, Skeleton } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { FaStethoscope } from "react-icons/fa6";
import { FaRegAddressCard } from "react-icons/fa";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdAccessTime } from "react-icons/md";
import UserImage from '../assets/usmon_logo.png';
import './LicensePageStyle.scss';
import { apiCall } from '../api/apiRoutes.ts';
import { message } from 'antd';
import { NetworkInfo } from "../constants/network.ts";
import { useDispatch } from "react-redux";
import { TbCurrencyDollar } from "react-icons/tb";
import { useAuth } from "../components/AuthContext.tsx";
import showMessageQueue from '../utils/messageUtils.js';

export interface LicensesState {
  assignedLicenses: number;
  availableLicenses: number;
}

const LicensePage: React.FC = () => {

  const columns = [
    {
      title: 'User Id',
      dataIndex: 'userid',
      key: 'userid',
      width: '350px',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Avatar src={UserImage} alt={text} />
          {text ? text : 'N/A'}
        </div>
      ),
    },
    {
      title: 'User Type',
      dataIndex: 'user_type',
      key: 'user_type',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {text ? text : '-'}
        </div>
      )
    },
    {
      title: 'Licenses',
      dataIndex: 'serviceIds',
      key: 'serviceIds',
      render: (serviceIds: any) => (
        <>
          {serviceIds?.map((license: any, index1: number) => (
            <Tag
              className="tag-text"
              color={license === 10001 ? "blue" : license === 10002 ? "green" : ""}
              key={index1}
            >
              {license === 10002 ? (
                <>
                  <TbCurrencyDollar />  Plus
                </>
              ) : license === 10001 ? (
                <>
                  <FaStethoscope />  Basic
                </>
              ) : (
                "No-License"
              )}
            </Tag>
          ))}
        </>
      ),
    },
    {
      title: 'Mother Company',
      dataIndex: ['webUserChild', 'client', 'client_mother_company'],
      key: 'mother_company',
      render: (text) => (text ? text : 'N/A'),
    },
    {
      title: 'Status',
      dataIndex: 'pending',
      key: 'pending',
      render: pending => (
        pending === true ? <Tag color="orange">PENDING</Tag> : null
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => {
        if (!record?.pending && (!record?.serviceIds || record?.serviceIds.length === 0)) {
          return null;
        }
        return (
          <Button
            icon={record?.pending ? <PlusOutlined /> : <EditOutlined />}
            onClick={() => {
              if (record?.pending) {
                showAddModal(record);
              } else {
                showEditModal(record);
              }
            }}
          />
        );
      },
    }
  ];
  const dispatch = useDispatch();
  const [messages, contextHolder] = message.useMessage();
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);
  const [licensesData, setLicensesData] = useState<LicensesState>({ assignedLicenses: 0, availableLicenses: 0 });
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [selectedPlanNewApplication, setSelectedPlanNewApplication] = useState(0)
  const [pendingLicensesData, setPendingLicensesData] = useState([])
  const [clientId, setClientId] = useState(0);
  const [records, setTotalRecords] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchState, setSearchState] = useState("");
  const [searchCall, setSearchCall] = useState(false);
  const [pendingLicenses, setPendingLicenses] = useState(0);
  const [searchedUsers, setSearchedUsers] = useState('');
  const [pendingDataLoaded, setPendingDataLoaded] = useState(false);
  const [isRecordEditable, setIsRecordEditable] = useState(false)
  const [selectAssignOrRemove, setSelectAssignOrRemove] = useState('')
  const [selectedPlanEditApplication, setSelectedPlanEditApplication] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [selectedPlanEditApplicationReplica, setSelectedPlanEditApplicationReplica] = useState(0)
  const [email, setEmail] = useState('')
  const [licenseLength, setLicenseLength] = useState(0)
  const [newLicenseLength, setNewLicenseLength] = useState(0)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const rowsPerPage = 10;
  const [userData, setUserData]: any = useState(null);
  const [selectedUserType, setSelectedUserType] = useState('');
  const [isRequestSubmit, setIsRequestSubmit] = useState(false);
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const [clientHasSubscription, setClientHasSubscription] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState<any>(null);
  const { catalog } = useAuth()
  const parsedUser = useMemo(() => {
    let storedUser = localStorage.getItem("usmonUser");
    return storedUser ? JSON.parse(storedUser) : {};
  }, []);
  const [subscriptionPlans, setSubscriptionPlans] = useState<any[]>([]);
  const [clientSubscriptions, setClientSubscriptions] = useState<any[]>([]);

  const fetchSubscriptionPlans = useCallback(async () => {
    try {
      const response: any = await apiCall({}, `${NetworkInfo.endpoints.subscription}${NetworkInfo.endpoints.plans}`, "get", false, false, false);
      if (response?.success && Array.isArray(response.data)) {
        setSubscriptionPlans(response.data);
      } else {
        setSubscriptionPlans([]);
      }
    } catch (err) {
      setSubscriptionPlans([]);
    }
  }, []);

  const fetchClientSubscriptions = useCallback(async () => {
    if (!clientId) return;
    try {
      const response: any = await apiCall(
        {},
        `${NetworkInfo.endpoints.subscription}${NetworkInfo.endpoints.client}?client_id=${clientId}`,
        "get",
        false,
        false,
        false
      );
      if (response?.success && response?.data?.subscriptions?.length > 0) {
        setClientSubscriptions(response.data.subscriptions);
        const enabledSub = response.data.subscriptions.find(
          (sub: any) => sub.subs_status === "enabled" && (sub.service_id === 10001 || sub.service_id === 10002)
        );
        if (enabledSub) {
          setClientHasSubscription(true);
          setSelectedSubscription(enabledSub);
        } else {
          setClientHasSubscription(false);
          setSelectedSubscription(null);
        }
      } else {
        setClientSubscriptions([]);
        setClientHasSubscription(false);
        setSelectedSubscription(null);
      }
    } catch (err) {
      setClientSubscriptions([]);
      setClientHasSubscription(false);
      setSelectedSubscription(null);
    }
  }, [clientId]);

  const isUserRole = parsedUser?.user?.insightsRole === "User";
  const isAdminRole = (parsedUser?.isUserAdmin === 'usmon-admin' || parsedUser?.isUserAdmin === 'client-admin') ? true : false;
  const isClientRole = parsedUser?.isUserAdmin === 'client-admin';

  const licenseOptions = useMemo(() => {
    return Array.isArray(catalog) ? catalog : [];
  }, [catalog]);

  let hasBasic = false;
  let hasPlus = false;
  let assignableLicenseOptions: any[] = [];
  const enabledSubs = clientSubscriptions.filter(sub => sub.subs_status === 'enabled');
  hasBasic = enabledSubs.some(sub => sub.service_id === 10001);
  hasPlus = enabledSubs.some(sub => sub.service_id === 10002);

  if (hasBasic && !hasPlus) {
    assignableLicenseOptions = licenseOptions.filter(opt =>
      typeof opt.service_category === 'string' &&
      opt.service_category.trim().toLowerCase() === 'basic'
    );
  } else if (hasBasic && hasPlus) {
    assignableLicenseOptions = licenseOptions.filter(opt =>
      typeof opt.service_category === 'string' &&
      ['basic', 'plus'].includes(opt.service_category.trim().toLowerCase())
    );
  }

  const purchaseSubscription = async (plan: any) => {
    const storedUser = localStorage.getItem("usmonUser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : {};
    const currentClientId = Object.keys(parsedUser?.user?.current_client)[0];
    setLoading(true);
    const data = {
      client_id: currentClientId,
      service_id: plan.service_id, // or plan.service_id if available
      tier: plan.name,
      user_count: plan.defaultLicensesOnPurchase || 1
    };

    try {
      const response: any = await apiCall(
        data,
        `${NetworkInfo.endpoints.subscription}`,
        "post",
        false,
        false,
        false
      );

      if (response?.success) {
        setSelectedSubscription({ ...plan, ...response.data.subscription });
        setClientHasSubscription(true);
        setLicensesData(prev => ({
          ...prev,
          availableLicenses: (prev.availableLicenses || 0) + (plan.defaultLicensesOnPurchase || 0)
        }));
        setIsSubscriptionModalOpen(false);
        showMessageQueue(messages, "success", response?.message || `Subscribed to ${plan.name}`);
        await fetchClientSubscriptions();
        await getAssignedData();
        await fetchUserAndLicenses(parsedUser.user.email);
      } else {
        showMessageQueue(messages, "error", response?.message || "Subscription failed");
      }
    } catch (err) {
      showMessageQueue(messages, "error", err?.response?.data?.message || "Subscription API failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    fetchSubscriptionPlans();
    return () => window.removeEventListener("resize", handleResize);
  }, [fetchSubscriptionPlans]);

  const finalLicenseOptions = useMemo(() => {
    return [
      ...licenseOptions,
      { service_id: 0, service_category: 'no-license', service_type: 'insights', description: '', initial_fee: '', license_fee: '' }
    ];
  }, [licenseOptions]);

  useEffect(() => {
    const getClientIdFromLocalStorage = () => {
      try {
        let storedUser = localStorage.getItem("usmonUser");
        let parsedUser = storedUser ? JSON.parse(storedUser) : {};
        const currentClientId = Object.keys(parsedUser?.user?.current_client)[0];
        const newClientId = Number(currentClientId);

        if (!isNaN(newClientId) && newClientId !== clientId) {
          setCurrentPage(1)
          setClientId(newClientId);
        }
      } catch (error) {
        console.error("Error parsing localStorage or extracting clientId:", error);
      }
    };

    getClientIdFromLocalStorage();
    const handleStorageChange = () => {
      getClientIdFromLocalStorage();
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [clientId]);

  useEffect(() => {
    if (clientId) {
      fetchClientSubscriptions();
    }
  }, [clientId, fetchClientSubscriptions]);

  const getPendingLicenseRequests = useCallback(async (): Promise<void> => {
    const cId: any = clientId;
    const data = {
      clientId: cId
    }
    try {
      const response: any = await apiCall(data, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.licenses}${NetworkInfo.endpoints.pending}?clientId=`, "get", true, true, false)
      if (response?.success) {
        setPendingLicensesData(response?.data);
        setDataSource(response?.data);
      } else {
        showMessageQueue(messages, "error", response?.message)
      }
    } catch (error) {
      showMessageQueue(messages, "error", error?.response?.data?.message || "Failed to fetch pending license requests")
    }
  }, [clientId, messages]);

  const getAssignedData = useCallback(async (): Promise<void> => {
    const cId: any = clientId;
    setLoading(true)
    const data = {
      clientId: cId
    }
    try {
      const response: any = await apiCall(data, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.licenses}${NetworkInfo.endpoints.assigned}?clientId=`, "get", true, true, false)
      if (response?.success) {
        let assignedCount = 0;
        let availableCount = 0;

        response?.data?.forEach((item: any) => {
          const totalQuantity = item.serviceIdInfo.reduce(
            (total, service) => total + service.quantity,
            0
          );

          if (item.status === "assigned") {
            assignedCount += totalQuantity;
          }
          if (item.status === "available") {
            availableCount += item.serviceIdInfo[0]?.quantity || 0;
          }
        });
        setLicensesData({
          assignedLicenses: assignedCount,
          availableLicenses: availableCount,
        });
        setLoading(false)
      }
      else if (response?.success === false) {
        showMessageQueue(messages, "error", response?.message)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      showMessageQueue(messages, "error", "Failed to fetch assigned licenses")
    }
  }, [clientId, messages]);

  const getUsersLicensesData = useCallback(async (): Promise<void> => {
    return new Promise((resolve, reject) => {
      let cid = clientId;

      let params: any = { page: currentPage, size: rowsPerPage, clientId: cid, user_type: selectedUserType === 'All' ? '' : selectedUserType };
      if (searchState) {
        params = { ...params, userid: searchState, page: 1 };
      }
      if (selectedValues.length) {
        params = { ...params, serviceIds: selectedValues };
      }
      const queryString = new URLSearchParams(params as any).toString();
      apiCall({}, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.client}${NetworkInfo.endpoints.user}?${queryString}`, "post", true, false, false).then((response: any) => {
        if (response?.success) {
          setTotalRecords(response?.data?.pagination?.totalRecords);
          let data: any = [];
          response?.data?.users.forEach((user: any, index) => {
            const userPendingLicenses = pendingLicensesData.filter(
              (license: any) => license?.userTarget === user?.userid && license?.actionType === 'ASSIGN'
            );
            if (userPendingLicenses.length > 0) {
              let obj: any = {
                ...user,
                pending: true,
                key: index,
                pendingLicenses: userPendingLicenses,
                actionType: 'ASSIGN'
              };
              data.push(obj);
            } else {
              let obj: any = {
                ...user,
                pending: false,
                key: index,
                pendingLicenses: [],
                actionType: 'none'
              };
              data.push(obj);
            }
          })
          setDataSource(data);
          resolve();
        } else {
          setDataSource([]);
          setTotalRecords(1);
          showMessageQueue(messages, "error", response?.message)
          reject(new Error(response?.message));
        }
      })
        .catch((error) => {
          console.log("Error fetching users licenses:", error);
          showMessageQueue(messages, "error", "Failed to fetch users licenses")
          reject(error);
        });
    })
  }, [clientId, currentPage, messages, pendingLicensesData, searchState, selectedValues, selectedUserType]);

  useEffect(() => {
    const fetchPendingData = async () => {
      if (clientId) {
        await getPendingLicenseRequests();
        await getAssignedData();
        setPendingDataLoaded(true);
      }
    };
    fetchPendingData();
  }, [clientId, getPendingLicenseRequests, getAssignedData]);

  useEffect(() => {
    const fetchData = async () => {
      if (clientId && pendingDataLoaded) {
        try {
          await getUsersLicensesData();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, [dispatch, currentPage, rowsPerPage, clientId, selectedValues, searchCall, pendingDataLoaded, getUsersLicensesData, selectedUserType]);

  const updateLicenseSelection = useCallback((userFound: any, hasPendingRequest: boolean, serviceIds: number[]) => {    
    if (userFound && userFound?.serviceIds?.length && !hasPendingRequest) {
      if (userFound?.serviceIds?.length === 1) {
        const find = licenseOptions?.find(
          (license: any) => license?.service_id !== userFound?.serviceIds[0]
        );
        setSelectedPlanNewApplication(find?.service_id);
        setNewLicenseLength(1);
      } else if (userFound?.serviceIds?.length === 2) {
        setSelectedPlanNewApplication(0);
        setNewLicenseLength(0);
      }
    } else if (userFound && userFound?.serviceIds?.length === 0 && !hasPendingRequest) {
      setSelectedPlanNewApplication(10001);
      setNewLicenseLength(2);
    } else if (
      userFound &&
      userFound?.serviceIds?.length === 0 &&
      hasPendingRequest &&
      serviceIds?.length === 1
    ) {
      const find = licenseOptions?.find(
        (license: any) => !serviceIds.includes(license?.service_id)
      );
      setSelectedPlanNewApplication(find?.service_id);
      setNewLicenseLength(1);
    } else {
      setSelectedPlanNewApplication(0);
      setNewLicenseLength(0);
    }
  },
    [licenseOptions]
  );

  const fetchUserAndLicenses = useCallback(
    async (email: string) => {
      if (!parsedUser) return;
      const cid: any = Object.keys(parsedUser.user.current_client)[0];
      try {
        const pendingResponse: any = await apiCall(
          { clientId: cid },
          `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.licenses}${NetworkInfo.endpoints.pending}?clientId=`,
          "get",
          true,
          true,
          false
        );
        if (pendingResponse?.success) {
          setPendingLicensesData(pendingResponse?.data);
          setDataSource(pendingResponse?.data);
        } else {
          showMessageQueue(messages, "error", pendingResponse?.message);
          return;
        }
        const params: any = { page: 1, size: 10, clientId: cid, userid: email };
        const queryString = new URLSearchParams(params as any).toString();

        const userResponse: any = await apiCall(
          {},
          `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.client}${NetworkInfo.endpoints.user}?${queryString}`,
          "post",
          true,
          false,
          false
        );

        if (userResponse?.success) {
          const userFound = userResponse?.data?.users[0];
          if (!userFound) return;

          let data: any = [];
          userResponse?.data?.users.forEach((user: any, index) => {
            const userPendingLicenses = pendingResponse.data.filter(
              (license: any) => license?.userTarget === user?.userid && license?.actionType === "ASSIGN"
            );

            let obj: any = {
              ...user,
              pending: userPendingLicenses.length > 0,
              key: index,
              pendingLicenses: userPendingLicenses,
              actionType: userPendingLicenses.length > 0 ? "ASSIGN" : "none"
            };
            data.push(obj);
          });

          const matchedUser: any = data.find(
            (user: any) => user.web_user_id === userFound.web_user_id
          );

          const serviceIds =
            matchedUser?.pendingLicenses?.map((lic: any) => lic?.serviceId) || [];

          const hasPendingRequest = data.some(
            (user: any) =>
              user?.web_user_id === userFound?.web_user_id &&
              user.pending === true &&
              user.actionType === "ASSIGN"
          );

          updateLicenseSelection(userFound, hasPendingRequest, serviceIds);
        } else {
          showMessageQueue(messages, "error", userResponse?.message);
        }
      } catch (error) {
        showMessageQueue(
          messages,
          "error",
          error?.response?.data?.message || "Failed to fetch pending license requests"
        );
      }
    },
    [parsedUser, messages, updateLicenseSelection]
  );

  useEffect(() => {
    if ((isUserRole && !isAdminRole) && parsedUser?.user?.email) {
      setSearchedUsers(parsedUser.user.email);
      fetchUserAndLicenses(parsedUser.user.email);
      if (licenseOptions.length > 0 && !selectedPlanNewApplication) {
        setSelectedPlanNewApplication(licenseOptions[0].service_id);
      }
    }
  }, [isUserRole, parsedUser?.user?.email, isRequestSubmit, fetchUserAndLicenses, isAdminRole, licenseOptions, selectedPlanNewApplication]);

  const handleChange = async (newValue: string) => {
    setSearchedUsers(newValue);
    if (newValue) {
      await fetchUserAndLicenses(newValue);
    }
  };

  const handleFocus = () => setIsFocused(true);

  const handleBlur = (value) => {
    setIsFocused(false);
    setHasValue(!!value);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showAddModal = (record: any) => {
    setUserData(record)
    setIsAddModalOpen(true)
  }

  const showEditModal = (record: any) => {
    setIsEditModalOpen(true);
    setEmail(record?.userid);
    setSelectedRecord(record);
    let userFound: any = dataSource.find(
      (user: any) => user?.userid === record?.userid && user?.serviceIds[0] === record?.serviceIds[0]
    );

    const assignedLicenses = userFound?.serviceIds || [];
    const licenseCount = assignedLicenses.length;
    setLicenseLength(licenseCount);

    if (record?.pending === false && licenseCount && record?.userid) {
      setIsRecordEditable(true);

      if (licenseCount === 1) {
        const assignedLicenseId = assignedLicenses[0];
        setSelectedPlanEditApplicationReplica(assignedLicenseId);
        const unassigned = licenseOptions.find(
          (opt: any) => opt?.service_id !== assignedLicenseId
        );
        if (unassigned) {
          setSelectedPlanEditApplication(unassigned.service_id);
        } else {
          setSelectedPlanEditApplication(0);
        }
        setSelectAssignOrRemove('assign');
      } else if (licenseCount === 2) {
        setSelectedPlanEditApplication(0);
        setSelectedPlanEditApplicationReplica(0);
        setSelectAssignOrRemove('remove');
      }
    } else {
      setIsRecordEditable(false);
      setSelectedPlanEditApplication(0);
      setSelectedPlanEditApplicationReplica(0);
      setSelectAssignOrRemove('');
      setLicenseLength(0);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSearchedUsers('')
    setSelectedPlanNewApplication(0)
    setNewLicenseLength(0)
  };

  const handleEditOk = () => {
    setIsEditModalOpen(false);
  };

  const handleAddOk = () => {
    setIsAddModalOpen(false);
  };

  const handleEditCancel = () => {
    setIsEditModalOpen(false);
    setSelectedPlanEditApplication(0)
    setSelectedPlanEditApplicationReplica(0)
    setLicenseLength(0)
    setIsRecordEditable(false)
    setEmail('')
    setSelectAssignOrRemove('')
  };

  const handleAddCancel = () => {
    setIsAddModalOpen(false);
  };

  useEffect(() => {
    const pendingAssigns = pendingLicensesData.filter((pl: any) => pl?.actionType === 'ASSIGN');
    const pendingAssignCountByType = pendingAssigns.reduce((acc: any[], curr: any) => {
      const existing = acc.find((item) => item.serviceId === curr.serviceId);
      if (existing) {
        existing.quantity += 1;
      } else {
        acc.push({ serviceId: curr.serviceId, quantity: 1 });
      }
      return acc;
    }, []);
    const pendingAssignTotal = pendingAssignCountByType.reduce((acc, cur) => acc + cur.quantity, 0);
    setPendingLicenses(pendingAssignTotal)
  }, [pendingLicensesData])

  const onCheckBoxChange = (checkedValues: any[]) => {
    let updatedValues = [...checkedValues];
    const lastItem = checkedValues[checkedValues.length - 1];
    if (lastItem === 0) {
      if (checkedValues.includes(0)) {
        updatedValues = [0];
        if (checkedValues.includes(1)) {

          updatedValues.push(1);
        }
      } else {
        updatedValues = checkedValues.filter(v => v !== 0);
      }
    } else if (lastItem === 1) {
      updatedValues = [...checkedValues];
      if (checkedValues.includes(0) && !updatedValues.includes(1)) {
        updatedValues.push(1);
      }
    }
    else {
      updatedValues = updatedValues.filter((value) => value !== 0);
    }
    if (updatedValues.includes(1)) {
      setSelectedValues(updatedValues);
      setCurrentPage(1);
      getPendingLicenseRequests();
    } else {
      setSelectedValues(updatedValues);
      setCurrentPage(1);
      setSearchCall(!searchCall);
    }
  };

  const onChangeNewLicense = (val: number) => {
    setSelectedPlanNewApplication(val)
  }

  const onChangeEditLicensePlan = (val: number) => {
    if (val !== selectedPlanEditApplicationReplica) {
      setSelectedPlanEditApplication(val)
    }
  }

  const assignOrRemoveLicense = (val) => {
    setSelectAssignOrRemove(val);
    if (val === 'remove') {
      setSelectedPlanEditApplication(selectedPlanEditApplicationReplica);
    }
    if (val === 'assign') {
      let userFound: any = dataSource.find(
        (user: any) => user?.userid === selectedRecord?.userid && user?.serviceIds[0] === selectedRecord?.serviceIds[0]
      );
      const assignedLicenses = userFound?.serviceIds || [];
      setSelectedPlanEditApplication(assignedLicenses[0]);
      const unassigned = licenseOptions.find(
        (opt: any) => opt?.service_id !== assignedLicenses[0]
      );
      if (unassigned) {
        setSelectedPlanEditApplication(unassigned.service_id);
      } else {
        setSelectedPlanEditApplication(0);
      }
    }
  }

  const handleTableChange = useCallback((pagination) => {
    setCurrentPage(pagination.current);
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchState(e?.target?.value);
    if (e?.target?.value === '') {
      setSearchCall(!searchCall)
    }
  };

  const handleSearchChangeApiCall = () => {
    setCurrentPage(1);
    setSearchCall(!searchCall)
  }

  const fetchNewAssignUsersList = (userid) => {
    return new Promise((resolve, reject) => {
      const params = {
        clientId: clientId,
        userid: userid,
      };
      const queryString = new URLSearchParams(params as any).toString();

      apiCall({}, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.client}${NetworkInfo.endpoints.listuser}?${queryString}`, "post", true, false, false)
        .then((response: any) => {
          if (response?.success) {
            let responseData = response?.data?.users.map((user, index) => ({
              label: user?.userid,
              value: `${user?.userid}`,
              key: `${user?.userid}-${index}`
            }));
            resolve(responseData);
          } else {
            showMessageQueue(messages, "error", response?.message);
            resolve([]);
          }
        })
        .catch((error) => {
          showMessageQueue(messages, "error", "Failed to fetch users licenses");
          reject(error);
        });
    });
  }

  const SelectUsers = ({ fetchOptions, ...props }) => {
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const fetchRef = useRef(0);

    const handleSearch = (value) => {
      if (value) {
        fetchRef.current += 1;
        const fetchId = fetchRef.current;
        setOptions([]);
        setFetching(true);
        setSelectedPlanNewApplication(0)
        fetchOptions(value)
          .then((newOptions) => {
            if (fetchId !== fetchRef.current) {
              return;
            }
            setOptions(newOptions);
          })
          .finally(() => setFetching(false));
      }
    };

    return (
      <Select
        showSearch
        filterOption={false}
        onSearch={handleSearch}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        {...props}
        value={searchedUsers}
        options={options}
        placeholder=""
        onFocus={handleFocus}
        onBlur={(value) => handleBlur(value)}
        onChange={(e: any) => { handleChange(e) }}
      />
    );
  }

  const requestNewLicense = async () => {
    const storedUser = localStorage.getItem("usmonUser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : {};
    const currentClientEmail = parsedUser?.user?.email;
    setLoading(true)
    const data = {
      clientId: clientId,
      userBy: currentClientEmail,
      serviceId: selectedPlanNewApplication,
      userTarget: searchedUsers,
      actionType: "assign",
      insightsRole: parsedUser?.user?.insightsRole
    }
    try {
      const response: any = await apiCall(data, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.licenses}${NetworkInfo.endpoints.request}`, "post", false, false, false);
      if (response?.success) {
        setLoading(false);
        setSearchedUsers('')
        setSelectedPlanNewApplication(0)
        getPendingLicenseRequests();
        getUsersLicensesData();
        getAssignedData();
        setIsModalOpen(false)
        showMessageQueue(messages, "success", response?.message)
        if (isUserRole) {
          setIsRequestSubmit(!isRequestSubmit);
        }
      }
      else if (response?.success === false) {
        showMessageQueue(messages, "error", response?.message)
        setLoading(false)
      }
    } catch (error) {
      console.log("error from request new license api", error);
      setSearchedUsers('')
      setSelectedPlanNewApplication(0)
      setNewLicenseLength(0)
      showMessageQueue(messages, "error", error?.response?.data?.message || "License limit of 20 reached for this client")
      setLoading(false)
      setIsModalOpen(false)
    }
  }

  const assignOrRemoveLicenses = async () => {
    const storedUser = localStorage.getItem("usmonUser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : {};
    const currentClientEmail = parsedUser?.user?.email;
    setLoading(true)
    const data = {
      clientId: clientId,
      userBy: currentClientEmail,
      serviceId: selectedPlanEditApplication,
      userTarget: email,
      actionType: selectAssignOrRemove,
      insightsRole: parsedUser?.user?.insightsRole
    }
    try {
      const response: any = await apiCall(data, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.licenses}${NetworkInfo.endpoints.request}`, "post", false, false, false);
      if (response?.success) {
        setLoading(false);
        setEmail('');
        setSelectedPlanEditApplication(0);
        setSelectAssignOrRemove('');
        setIsEditModalOpen(false)
        setIsRecordEditable(false)
        getPendingLicenseRequests();
        getUsersLicensesData();
        getAssignedData();
        showMessageQueue(messages, "success", response?.message)
      }
      else if (response?.success === false) {
        showMessageQueue(messages, "error", response?.message)
        setLoading(false)
      }
    } catch (error) {
      showMessageQueue(messages, "error", error?.response?.data?.message ? error?.response?.data?.message : "Client has reached the maximum license limit (20) for basic/plus services")
      setLoading(false);
    }
  }

  const handleAssignRemoveLicense = async () => {
    const storedUser = localStorage.getItem("usmonUser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : {};
    const currentClientEmail = parsedUser?.user?.email;
    setLoading(true)
    const data = {
      clientId: clientId,
      userBy: currentClientEmail,
      serviceId: userData?.pendingLicenses?.length > 0 ? userData?.pendingLicenses?.map((license) => license?.serviceId) : [],
      userTarget: userData?.userid,
      actionType: userData?.actionType
    }
    try {
      const response: any = await apiCall(data, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.licenses}${NetworkInfo.endpoints.approve}`, "post", false, false, false);
      if (response?.success) {
        setLoading(false);
        setUserData(null)
        setIsAddModalOpen(false)
        getPendingLicenseRequests();
        getUsersLicensesData();
        getAssignedData();
        showMessageQueue(messages, "success", response?.message)
      }
      else if (response?.success === false) {
        showMessageQueue(messages, "error", response?.message)
        setLoading(false)
      }
    } catch (error) {
      showMessageQueue(messages, "error", error?.response?.data?.message || "Failed to approve license request")
      setLoading(false)
    }
  }

  const renderRequestFormContent = () => (
    <div className={(isUserRole && !isAdminRole) ? 'request-license-page' : ''}>
      <div className={(isUserRole && !isAdminRole) ? 'request-license-card' : ''}>
        {(isUserRole && !isAdminRole) && <h2 className="form-title">Request New License</h2>}
        <div className='licenses-Detected-Box'>
          <div className='Detected-icon'>
            <IoMdInformationCircleOutline />
          </div>
          <div className='Detected-detail'>
            {(isUserRole && !isAdminRole) ? (
              <>
                <h4>Request a license</h4>
                <p>You may request a license from your client administrator.</p>
              </>
            ) : assignableLicenseOptions.length === 0 ? (
              <>
                <h4>No active subscription found</h4>
                <p>You must purchase a subscription before assigning licenses.</p>
              </>
            ) : (
              <>
                <h4>Available Licenses Detected</h4>
                <p>Before requesting a new license, please note that you already have licenses available for use.</p>
              </>
            )}
          </div>
        </div>
        <div className="input-wrap">
          <label className="label-text">SELECT A USER</label>
          <p className='mb-0'>First select a user.</p>
          <div className={`antd-floating-label-select ${isFocused || hasValue ? "focused" : ""}`}>
            {(isUserRole && !isAdminRole) ?
              <>
                <Select
                  value={searchedUsers}
                  style={{ width: "100%" }}
                  open={false}
                  disabled
                />
              </>
              :
              <>
                <label className="antd-floating-label">Search by email</label>
                <SelectUsers
                  value={searchedUsers}
                  placeholder="Select users"
                  fetchOptions={
                    (isUserRole && !isAdminRole)
                      ? () => Promise.resolve([{ label: parsedUser.user.email, value: parsedUser.user.email }])
                      : fetchNewAssignUsersList
                  }
                  onChange={(newValue) => setSearchedUsers(newValue)}
                  style={{ width: "100%" }}
                />
              </>}
          </div>
        </div>
        <div className="input-wrap gap-0">
          {assignableLicenseOptions?.length > 0 && (
            <>
              <label className="label-text">LICENSE TYPE</label>
              <p>Then select the type of license you want to request for the selected user.</p>
            </>
          )}
          <Radio.Group
            style={{ width: "100%" }}
            value={selectedPlanNewApplication}
            onChange={(e) => onChangeNewLicense(e?.target?.value)}
            disabled={
              !searchedUsers ||
              ((isClientRole || isAdminRole)
                ? assignableLicenseOptions?.length === 0
                : licenseOptions?.length === 0)
            }
            className='d-flex'
          >
            {(isClientRole || isAdminRole
              ? assignableLicenseOptions
              : licenseOptions
            )?.map((option) => {              
              return (
                <div key={option?.service_id}>
                <Radio
                  value={option?.service_id}
                  disabled={
                    newLicenseLength === 1
                      ? option?.service_id !== selectedPlanNewApplication
                      : newLicenseLength === 2
                        ? false
                        : !selectedPlanEditApplication
                  }
                >
                  {option?.service_category.charAt(0).toUpperCase() + option?.service_category.slice(1)}
                </Radio>
              </div>
              )
            })}
          </Radio.Group>
        </div>
        <div className='modal-footer'>
          {isAdminRole && <button type="button" className="primary-btn blank" onClick={handleCancel}>
            <span>Cancel</span>
          </button>}
          <button
            type="button"
            className="primary-btn"
            disabled={
              (isClientRole || isAdminRole)
                ? (!selectedPlanNewApplication || assignableLicenseOptions?.length === 0)
                : !selectedPlanNewApplication
            }
            onClick={() => requestNewLicense()}
          >
            <span>{(isUserRole && !isAdminRole) ? "Request Changes" : "Assign"}</span>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className='main-wrapper'>
      {contextHolder}
      <div className="license-container">
        <div className='container'>
          {isAdminRole &&
            <h2 className="license-title">License Management</h2>}

          {isAdminRole &&
            <Row gutter={16} className="license-cards">
              <Col lg={8} md={8} sm={12} xs={24}>
                <Card title="Assigned Licenses" variant="borderless" className="license-card">
                  <FaStethoscope /> {licensesData?.assignedLicenses}
                </Card>
              </Col>
              <Col lg={8} md={8} sm={12} xs={24}>
                <Card title="Available Licenses" variant="borderless" className="license-card">
                  <FaRegAddressCard /> {licensesData?.availableLicenses}
                </Card>
              </Col>
              <Col lg={8} md={8} sm={12} xs={24}>
                <Card title="Pending Licenses" variant="borderless" className="license-card">
                  <MdAccessTime /> {pendingLicenses}
                </Card>
              </Col>
            </Row>
          }

          <div className={isAdminRole ? "license-filters" : ""}>
            {isAdminRole && 
            <div className='filters-right'>              
                <div className='input-wrap search-input'>
                  <label className='label-text'>SEARCH BY USER EMAIL</label>
                  <InputGroup>
                    <FloatingLabel controlId="floatingInput" label="User email" className="flex-grow-1">
                      <Form.Control
                        type="search"
                        placeholder="User email"
                        value={searchState}
                        onChange={handleSearchChange}
                      />
                    </FloatingLabel>
                    <InputGroup.Text onClick={handleSearchChangeApiCall}>
                      <FaSearch />
                    </InputGroup.Text>
                  </InputGroup>
                </div>              
                <div className="input-wrap category-filter" style={{ minWidth: "200px" }}>
                  <label className="label-text">USER TYPE</label>
                  <FloatingLabel controlId="floatingSelectUserType" label="User Type">
                    <Form.Select
                      aria-label="User type"
                      value={selectedUserType || ""}
                      onChange={(e) => {
                        setSelectedUserType(e.target.value);
                        setCurrentPage(1);
                        setSearchCall(!searchCall);
                      }}
                    >
                      <option value="">All</option>
                      <option value="User">User</option>
                      <option value="Admin">Admin</option>
                    </Form.Select>
                  </FloatingLabel>
                </div>                   
                <div className='input-wrap'>
                  <label className='label-text'>FILTER BY LICENSE & STATUS</label>
                  <div className='checkbox-wrap d-flex mt-2'>
                    <Checkbox.Group
                      style={{ width: "100%" }}
                      value={selectedValues}
                      onChange={onCheckBoxChange}
                    >
                      {finalLicenseOptions.map((option) => (
                        <div key={option?.service_id} className="custom-checkbox">
                          <Checkbox value={option?.service_id}>
                            {option?.service_category.charAt(0).toUpperCase() + option?.service_category.slice(1)}
                          </Checkbox>
                        </div>
                      ))}
                      <div key="pending" className="custom-checkbox">
                        <Checkbox value={1}>Pending-license</Checkbox>
                      </div>
                    </Checkbox.Group>
                  </div>
                </div>         
            </div>}

            {(isUserRole && !isAdminRole) ? (
              <div className="inline-request-form">
                {renderRequestFormContent()}
              </div>
            ) : (
              <>
                {isClientRole && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <Button type="primary" className="primary-btn" onClick={() => setIsSubscriptionModalOpen(true)}>
                      Purchase Subscription
                    </Button>
                    <Button type="primary" className="primary-btn" onClick={showModal}>
                      Assign New License
                    </Button>
                    {!clientHasSubscription && (
                      <div style={{ fontSize: 13, color: '#555' }}>
                        <div>Clients must purchase a subscription to have available licenses.</div>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>

          {isAdminRole && (loading ?
            (
              Array.from({ length: rowsPerPage }).map((_, index) => (
                <Skeleton key={index} active avatar paragraph={{ rows: 2 }} />
              ))
            ) :
            <Table
              dataSource={dataSource || []}
              columns={columns || []}
              className="license-table"
              pagination={
                {
                  pageSize: rowsPerPage,
                  total: records,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                  current: currentPage,
                  showSizeChanger: false
                }
              }
              scroll={screenWidth < 1200 ? { x: 1100 } : undefined}
              tableLayout="auto"
              onChange={handleTableChange}
            />)
          }

        </div>
      </div>

      {isAdminRole && (
        <Modal
          className='Request-modal'
          title="Assign New License"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          centered
        >
          {renderRequestFormContent()}
        </Modal>
      )}

      <Modal className='Request-modal' title="Assign or Remove License" open={isEditModalOpen} onOk={handleEditOk} onCancel={handleEditCancel} centered>
        <div className="input-wrap">
          <label className="label-text">SELECTED USER</label>
          <p className='mb-0'>Only one license can be assigned or removed at a time.</p>

          <div className={`antd-floating-label-select ${isFocused || hasValue ? "focused" : ""}`}>
            <Input value={email} disabled />
          </div>

          <Radio.Group
            className="d-flex gap-12 flex-column mb-4"
            value={selectAssignOrRemove}
            disabled={!isRecordEditable}
            onChange={(e: any) => assignOrRemoveLicense(e?.target?.value)}
          >
            <Radio
              value="assign"
              disabled={!isRecordEditable || licenseLength !== 1}
            >
              Assign 1 of your available licenses
            </Radio>
            <Radio
              value="remove"
              disabled={!isRecordEditable}
            >
              Remove 1 license from the user
            </Radio>

          </Radio.Group>
        </div>

        {isRecordEditable ?
          <div className='available-licenses-box'>
            <div className="input-wrap gap-0">
              <label className="label-text">AVAILABLE LICENSES</label>
              <p>Select one of your available licenses. If a license is already owned, it cannot be selected.</p>
              <Radio.Group
                style={{ width: "100%" }}
                value={selectedPlanEditApplication}
                onChange={(e: any) => onChangeEditLicensePlan(e?.target?.value)}
                disabled={!isRecordEditable}
                className="d-flex"
              >
                {licenseOptions.map((option) => {                  
                  return <div key={option?.service_id}>
                    <Radio
                      value={option?.service_id}
                      disabled={
                        !isRecordEditable ||
                        (selectAssignOrRemove === 'assign' &&
                          licenseLength === 1 &&
                          option?.service_id === selectedPlanEditApplicationReplica) ||
                        (selectAssignOrRemove === 'remove' &&
                          licenseLength === 1 &&
                          option?.service_id !== selectedPlanEditApplicationReplica)
                      }
                    >
                      {option?.service_category.charAt(0).toUpperCase() + option?.service_category.slice(1)}
                    </Radio>
                  </div>
                })}
              </Radio.Group>
            </div>
          </div>
          : <></>}

        <div className='modal-footer'>
          <button type="button" className="primary-btn blank" onClick={handleEditCancel}><span>Cancel</span></button>
          <button type="button" className="primary-btn" disabled={isRecordEditable === false || !selectedPlanEditApplication} onClick={assignOrRemoveLicenses}><span>Request Changes</span></button>
        </div>
      </Modal>

      <Modal className='Request-modal' title={userData?.actionType === 'ASSIGN' ? 'Assign License' : 'Remove License'} open={isAddModalOpen} onOk={handleAddOk} onCancel={handleAddCancel} centered>
        <div className="input-wrap">
          <label className="label-text">SELECTED USER</label>
          <Input value={userData?.userid} disabled />
        </div>

        <div className="input-wrap">
          <label className="label-text mt-3">YOUR LICENSES</label>
          {
            userData?.pendingLicenses?.length > 0 ? (
              <strong>
                {licenseOptions
                  .filter(service =>
                    userData?.pendingLicenses.some(
                      pending => Number(pending.serviceId) === Number(service.service_id)
                    )
                  )
                  .map(service => service.service_category?.toUpperCase())
                  .join(", ")}
              </strong>
            ) : (
              <strong>No Licenses Found</strong>
            )
          }
        </div>
        <div className='modal-footer'>
          <button type="button" className="primary-btn blank" onClick={handleAddCancel}><span>Cancel</span></button>
          <button type="button"
            className="primary-btn"
            disabled={!userData?.userid}
            onClick={handleAssignRemoveLicense}>
            <span>{userData?.actionType === 'ASSIGN' ? 'Approve' : 'Remove'}</span>
          </button>
        </div>
      </Modal>

      {/* <Modal
        className="Subscription-modal"
        title="Purchase Subscription"
        open={isSubscriptionModalOpen}
        onCancel={() => setIsSubscriptionModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsSubscriptionModalOpen(false)}>
            Cancel
          </Button>
        ]}
        centered
        width={1200}
      >
        <Row gutter={[16, 16]}>
          {subscriptionPlans.map(plan => {
            const isBasic = plan.name === 'Insights Basic';
            const isPlus = plan.name === 'Insights Plus';
            const basicPurchased = clientSubscriptions.some(sub => sub.service_id === 10001 && sub.subs_status === 'enabled');
            const plusPurchased = clientSubscriptions.some(sub => sub.service_id === 10002 && sub.subs_status === 'enabled');
            let disabled = false;
            let buttonText = `Purchase ${plan.name}`;
            if (!isBasic && !isPlus) {
              disabled = true;
              buttonText = 'Not Offered Yet';
            } else if (isBasic && basicPurchased) {
              disabled = true;
              buttonText = 'Purchased';
            } else if (isPlus && plusPurchased) {
              disabled = true;
              buttonText = 'Purchased';
            } else if (isPlus && !basicPurchased) {
              disabled = true;
              buttonText = 'Require Basic';
            }
            return (
              <Col span={12} key={plan.tier}>
                <Card title={plan.name} bordered style={!isBasic && !isPlus ? { opacity: 0.5 } : {}}>
                  <p><strong>Cost:</strong> {plan.cost}</p>
                  <p><strong>Initial:</strong> {plan.initial}</p>
                  <p><strong>Additional User:</strong> {plan.addUser}</p>
                  <Button
                    type="primary"
                    loading={loading && selectedSubscription?.tier === plan.tier}
                    onClick={() => !disabled ? purchaseSubscription(plan) : null}
                    disabled={disabled}
                  >
                    {buttonText}
                  </Button>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Modal> */}

   <Modal
  className="Subscription-modal"
  title={<h2 style={{ textAlign: "center", marginBottom: 0 }}>Purchase Subscription</h2>}
  open={isSubscriptionModalOpen}
  onCancel={() => setIsSubscriptionModalOpen(false)}
  footer={[
    <Button key="cancel" onClick={() => setIsSubscriptionModalOpen(false)}>
      Cancel
    </Button>,
  ]}
  centered
  width="90%" // ✅ Responsive modal width
  style={{ maxWidth: "1000px" }} // ✅ Limit max width
>
  <Row gutter={[16, 16]} justify="center">
    {subscriptionPlans.map((plan) => {
      const isBasic = plan.name === "Insights Basic";
      const isPlus = plan.name === "Insights Plus";
      const basicPurchased = clientSubscriptions.some(
        (sub) => sub.service_id === 10001 && sub.subs_status === "enabled"
      );
      const plusPurchased = clientSubscriptions.some(
        (sub) => sub.service_id === 10002 && sub.subs_status === "enabled"
      );

      let disabled = false;
      let buttonText = `Purchase ${plan.name}`;
      if (!isBasic && !isPlus) {
        disabled = true;
        buttonText = "Not Offered Yet";
      } else if (isBasic && basicPurchased) {
        disabled = true;
        buttonText = "Purchased";
      } else if (isPlus && plusPurchased) {
        disabled = true;
        buttonText = "Purchased";
      } else if (isPlus && !basicPurchased) {
        disabled = true;
        buttonText = "Require Basic";
      }

      return (
        <Col xs={24} sm={12} md={12} lg={12}  key={plan.tier}>
          <Card
            hoverable
            bordered={false}
            style={{
              borderRadius: "12px",
              textAlign: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              padding: "20px",
              background: isPlus ?  "#fdfdf0ff" : isBasic ? "#f0f9ff" : "#fff",
              opacity: !isBasic && !isPlus ? 0.7 : 1,
              transition: "all 0.3s ease",
            }}
            className="subscription-card"
          >
            {/* Plan Name */}
            <h3 style={{ marginBottom: "10px", fontWeight: 600 }}>{plan.name}</h3>

            {/* Price Highlight */}
            <h2 style={{ fontSize: "22px", color: "#1890ff", marginBottom: "8px" }}>
              {plan.cost}
            </h2>

            {/* Sub Info */}
            <div style={{ fontSize: "13px", color: "#555", marginBottom: "16px" }}>
              <p><strong>Initial:</strong> {plan.initial}</p>
              <p><strong>Additional User:</strong> {plan.addUser}</p>
            </div>

            {/* Action Button */}
            <Button
              type={disabled ? "default" : "primary"}
              size="middle"
              style={{
                borderRadius: "8px",
                width: "100%",
              }}
              className="primary-btn"
              loading={loading && selectedSubscription?.tier === plan.tier}
              onClick={() => (!disabled ? purchaseSubscription(plan) : null)}
              disabled={disabled}
            >
              {buttonText}
            </Button>
          </Card>
        </Col>
      );
    })}
  </Row>

  {/* Hover effect CSS */}
  <style jsx>{`
    .subscription-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    }
  `}</style>
</Modal>

    </div>
  );
};

export default LicensePage;